import { filtersApi } from '../../../../common/networking/filters'
import { AppThunk } from '../../../store'
import {
  getFiltersFailure,
  getFiltersPending,
  getFiltersSuccess,
  setActiveFilters,
  setFavoriteFilter,
  setTimeFilter,
} from '.'

const { fetchFilters } = filtersApi()
let latestFiltersRequestId = 0

export const getFilters = (): AppThunk => async (dispatch) => {
  const requestId = ++latestFiltersRequestId
  dispatch(getFiltersPending(true))
  try {
    const response = await fetchFilters()

    if (requestId !== latestFiltersRequestId) return

    dispatch(getFiltersSuccess(response))
  } catch (error: any) {
    if (requestId !== latestFiltersRequestId) return

    dispatch(getFiltersFailure(error.toString()))
  }
}

export const setFilters =
  (tagFilters: number[], hideCompleted: boolean): AppThunk =>
  (dispatch) => {
    dispatch(setActiveFilters({ tags: tagFilters, hideCompleted }))
  }

export const setFavorite =
  (filterState: boolean): AppThunk =>
  (dispatch) => {
    dispatch(setFavoriteFilter(filterState))
  }

export const setTime =
  (startTime: string, endTime: string): AppThunk =>
  (dispatch) => {
    dispatch(setTimeFilter({ startTime: startTime, endTime: endTime }))
  }
